import { takeLatest, call, put } from "redux-saga/effects";
import { INVITE_RECRUITER_REQUEST } from "../../actionTypes";

import { inviteRecruiterSuccess, inviteRecruiterFailure } from "./actions";
import AxiosInstance from "../../../services/AxiosInstance";
// Worker saga
function* inviteRecruiter(action) {
  try {
    const response = yield call(() =>
      AxiosInstance().post("/recruiter/send_team_invitation", action.payload)
    );
    console.log("res", response.data);
    if (response.data.status == true) {
      yield put(inviteRecruiterSuccess(response.data));
    } else {
      yield put(inviteRecruiterFailure(response.data));
    }
  } catch (error) {
    yield put(
      inviteRecruiterFailure({ status: false, message: error.message })
    );
  }
}

// Watcher saga
function* inviteRecruiterSaga() {
  yield takeLatest(INVITE_RECRUITER_REQUEST, inviteRecruiter);
}
export default inviteRecruiterSaga;
